import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import Boost from "highcharts/modules/boost";

Boost(Highcharts); // Enable boost module

const HighchartFromText = ({ chartText }) => {
  const [originalData, setOriginalData] = useState(null);
  const [options, setOptions] = useState(null);
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    try {
      if (chartText) {
        const parsed = JSON.parse(chartText);
        if (parsed) {
          setSummary(parsed.summary || null);
          setOriginalData({
            name: parsed.chart_data.name,
            categories: parsed.chart_data.xAxis,
            series: parsed.chart_data.series,
          });
        }
      }
    } catch (err) {
      console.error("Error parsing chartText JSON:", err);
    }
  }, [chartText]);

  useEffect(() => {
    if (!originalData) return;

    const newOptions = {
      title: { text: originalData.name },
      xAxis: {
        categories: originalData.categories,
      },
      yAxis: {
        title: { text: "Value" },
      },
      tooltip: {
        shared: true,
        crosshairs: true,
      },
      series: originalData.series.map((s) => ({
        ...s,
        type: "line",
      })),
    };
    setOptions(newOptions);
  }, [originalData]);

  return (
    <div>
      {options ? (
        <>
          <HighchartsReact highcharts={Highcharts} options={options} />
        </>
      ) : (
        <>
          <p
            className="text-center"
            style={{
              fontWeight: "bold",
              color: "#000", // Default text color
              animation: "blink 1s infinite",
            }}
          >
            ... Loading Data ...
          </p>
          <style>
            {`
  @keyframes blink {
    0%, 100% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
  }
`}
          </style>
        </>
      )}
      {summary && (
        <p>
          <b>{summary}</b>
        </p>
      )}
    </div>
  );
};

export default HighchartFromText;
